// extracted by mini-css-extract-plugin
export default {"result":"nv_UclfU","mobile":"mobile","_centered":"VkT9E6Hk","text":"i8CTKyBY","link":"caqd18cm"};